// All static strings, config, and magic numbers for Dashboard feature
export const MOBILE_CHAT_HEADER_ICON = "pi pi-arrow-left";
export const MOBILE_CHAT_HEADER_CLASS = "p-button-text";
export const CHAT_MOBILE_VIEW_CLASS = "chat-mobile-view";
export const CHAT_MOBILE_HEADER_CLASS = "chat-mobile-header";
export const CHAT_MOBILE_TITLE_CLASS = "chat-mobile-title";
export const CHAT_LAYOUT_CLASS = "chat-layout";
export const CHAT_MAIN_CLASS = "chat-main";
export const DEFAULT_CHAT_TITLE = "Chat";
export const CHAT_LIST_ITEM_CLASS = "chat-list-item";
export const FIRST_TIME_LOGIN = "/first-time-setup";
